import { consentCategoryId } from '../fixture-ids';

export const consentCategoryEntries = {
  CONSENT_CATEGORY_CREATED: {
    entity: 'consentCategory',
    identity: 'record',
    idKeys: ['consentCategoryId'],
    renderMode: 'diff',
    createsRecord: true,
  },
  // Legacy rows carry no id at all — their alternate identity (a self-referential parentNameKeys
  // on consentCategoryName) belongs to the legacy alternate, never to this entry: declared here, it
  // would flag every current-generation row unattributed.
  CONSENT_CATEGORY_UPDATED: {
    entity: 'consentCategory',
    identity: 'record',
    idKeys: ['consentCategoryId'],
    renderMode: 'diff',
    createsRecord: false,
  },
  // Soft delete (deleted_at transition) -- full snapshot, all three keys present.
  CONSENT_CATEGORY_DELETED: {
    entity: 'consentCategory',
    identity: 'record',
    idKeys: ['consentCategoryId'],
    renderMode: 'diff',
    createsRecord: false,
  },
};

export const consentCategoryFixtures = {
  CONSENT_CATEGORY_CREATED: {
    action: 'CONSENT_CATEGORY_CREATED',
    debugData: { consentCategoryId, consentCategoryName: 'Marketing', consentCategoryCode: 'MARKETING' },
  },
  CONSENT_CATEGORY_UPDATED: {
    action: 'CONSENT_CATEGORY_UPDATED',
    debugData: { consentCategoryId, consentCategoryName: 'Marketing Communications', consentCategoryCode: 'MARKETING' },
  },
  CONSENT_CATEGORY_DELETED: {
    action: 'CONSENT_CATEGORY_DELETED',
    debugData: { consentCategoryId, consentCategoryName: 'Marketing Communications', consentCategoryCode: 'MARKETING' },
  },
};
